import { useState } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Button } from '@components/button';
import { Select } from '@components/select';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { Loading } from 'components/Loading';
import ShowMore from 'components/ShowMore';
import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

function MoveToStageModal({ job, applicants, closeModal, onSuccess }) {
  const [selected, setSelected] = useState(0);
  const [saving, setSaving] = useState(false);
  const { t } = useStore();

  async function moveToStage() {
    setSaving(true);
    const success = await job.bulkMoveToStage(applicants, selected);
    setSaving(false);
    if (success) {
      onSuccess?.(selected);
      closeModal();
    }
  }

  function selectStage(stage) {
    setSelected(stage);
  }

  return (
    <Modal>
      <Modal.Header text={t('modals.movetostage.heading')} />

      <Stack space={4}>
        {saving && <Loading />}
        <Text text={t('modals.movetostage.applicantsmsg')} />
        <ShowMore
          max={applicants.length}
          count={applicants.length > 10 ? 5 : applicants.length}
          inc={1000}
          render={({ count }) => (
            <List>
              {applicants.slice(0, count).map((a, i) => (
                <div key={i}>{a.name}</div>
              ))}
            </List>
          )}
        />
        <Text text={t('modals.movetostage.stagemsg')} />
        <Select
          isSearchable={false}
          isClearable={false}
          options={job.applicantJobStages}
          placeholder={t('modals.movetostage.stage.select')}
          onChange={selectStage}
        />
      </Stack>

      <Modal.Actions>
        <Button
          variant="secondary"
          onClick={closeModal}
          isDisabled={saving}
          text={t('modals.movetostage.button.cancel')}
        />
        <Button
          onClick={saving || selected.length === 0 ? null : moveToStage}
          isDisabled={saving || selected.length === 0}
          text={t('modals.movetostage.button.submit')}
        />
      </Modal.Actions>
    </Modal>
  );
}

export default observer(MoveToStageModal);

const List = styled.div`
  color: ${(p) => p.theme.textColor};
  font-weight: bold;
  margin-bottom: 20px;
`;
